import Controller from "./backup.controller";
import template from "./backup.html";

const backup = {
  template,
  controller: Controller,
};

export default backup;



// WEBPACK FOOTER //
// ./src/pages/backup/backup.component.js